import { getInterviewSectionTitle } from "@repo/app-types/entities/interviewSection/definition";
import { type FC, useState } from "react";
import { Heading } from "react-aria-components";
import type { VisibleInterviewSectionDefinition } from "../interviewSections/definitions/state.js";
import { LessonAttemptSelect } from "./lessonAttemptSelect.js";
import { LessonTranscript } from "./lessonTranscript.js";

export interface LessonDetailProps {
  projectId: string;
  participantId: string;
  selectedLessonNumber: `${number}.${number}` | undefined;
  selectedSection: VisibleInterviewSectionDefinition;
}

export const LessonDetail: FC<LessonDetailProps> = (props) => {
  const [selectedAttemptId, setSelectedAttemptId] = useState<string | null>(
    null,
  );

  const lessonTitle = getInterviewSectionTitle(props.selectedSection.settings);

  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <Heading
          level={3}
          className="truncate text-base leading-7 font-semibold text-foreground"
        >
          {props.selectedLessonNumber
            ? `Lesson ${props.selectedLessonNumber}: `
            : null}
          {lessonTitle}
        </Heading>

        <div className="-my-1">
          <LessonAttemptSelect
            projectId={props.projectId}
            participantId={props.participantId}
            interviewSectionDefinitionId={props.selectedSection.id}
            value={selectedAttemptId}
            onChange={setSelectedAttemptId}
          />
        </div>
      </div>

      <LessonTranscript
        title={
          props.selectedLessonNumber
            ? `Lesson ${props.selectedLessonNumber}: ${lessonTitle}`
            : lessonTitle
        }
        projectId={props.projectId}
        participantId={props.participantId}
        interviewSectionDefinitionId={props.selectedSection.id}
        interviewSectionResultId={selectedAttemptId ?? undefined}
      />
    </>
  );
};
